import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=17206d62&"
import script from "./scene.vue?vue&type=script&lang=ts&"
export * from "./scene.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports